// import { useLocation } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";

export default function CreateProject() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    playlistlink: "",
    title: "",
    totalvideos: 0,
    totalduration: 0,
  });
  const handleChange = (event) => {
    setFormData((oldFormData) => {
      return { ...oldFormData, [event.target.name]: event.target.value };
    });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const playlistId = formData.playlistlink.split("=")[2];
      let youtubeResponse = await axios.get(
        `https://www.googleapis.com/youtube/v3/playlistItems?playlistId=${playlistId}&key=AIzaSyAHy-5RrGxqiC1gyBtdeyRiERqXzRKRaIw&part=snippet,contentDetails&maxResults=50`
      );
      console.log(youtubeResponse.data);
      let videos = [];
      let videosFetched = 0;
      const playlistThumbnail =
        youtubeResponse.data.items[0].snippet.thumbnails.medium.url;
      while (true) {
        youtubeResponse.data.items.forEach((item) => {
          videos.push({
            videolink: item.snippet.resourceId.videoId,
            isCompleted: false,
            title: item.snippet.title,
          });
        });
        videosFetched += youtubeResponse.data.pageInfo.resultsPerPage;
        if (videosFetched > youtubeResponse.data.pageInfo.totalResults) break;
        youtubeResponse = await axios.get(
          `https://www.googleapis.com/youtube/v3/playlistItems?playlistId=${playlistId}&key=AIzaSyAHy-5RrGxqiC1gyBtdeyRiERqXzRKRaIw&part=snippet,contentDetails&maxResults=50&pageToken=${youtubeResponse.data.nextPageToken}`
        );
      }
      const sendData = {
        youtubelink: formData.playlistlink,
        title: formData.title,
        totalvideos: videos.length,
        completedVideos: 0,
        thumbnail: playlistThumbnail,
        videos: videos,
      };
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/dashboard/create-project`,
        sendData
      );
      toast.success(res.data.message);
      navigate("/dashboard");
    } catch (err) {
      toast.error("Some unknown error occurred");
    }
  };
  return (
    <div className="min-h-full w-full">
      <Header />
      <form className="w-fit mx-auto mt-32 bg-slate-400 px-14 py-8 rounded-3xl">
        <div className="border-b border-gray-900/10 pb-12 w-96">
          <h1 className="text-3xl font-semibold leading-7 text-gray-900">
            PROJECT INFO
          </h1>

          <div className="mt-10">
            <label
              htmlFor="playlistlink"
              className="block text-sm font-medium text-gray-900"
            >
              Youtube Playlist Link
            </label>
            <div className="mt-2">
              <input
                id="playlistlink"
                name="playlistlink"
                type="text"
                autoComplete="email"
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                value={formData.playlistlink}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="mt-10">
            <label
              htmlFor="title"
              className="block text-sm font-medium text-gray-900"
            >
              Title
            </label>
            <div className="mt-2">
              <input
                id="title"
                name="title"
                type="text"
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                value={formData.title}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="mt-10">
            <label
              htmlFor="totalvideos"
              className="block text-sm font-medium text-gray-900"
            >
              Total Videos
            </label>
            <div className="mt-2">
              <input
                id="totalvideos"
                name="totalvideos"
                type="text"
                className="bg-gray-300 block w-full rounded-md border-0 py-1.5 text-slate-400 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                value={formData.totalvideos}
                disabled={true}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="mt-10">
            <label
              htmlFor="totalduration"
              className="block text-sm font-medium text-gray-900"
            >
              Total Duration
            </label>
            <div className="mt-2">
              <input
                id="totalduration"
                name="totalduration"
                type="text"
                className="bg-gray-300 block w-full rounded-md border-0 py-1.5 text-slate-400 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                value={formData.totalduration}
                disabled={true}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="mt-6 flex items-center justify-end gap-x-6">
          <button
            type="button"
            className="text-sm font-semibold leading-6 text-gray-900"
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
}
